/**
 * Script Action 命名空间
 */
export const scriptActionNamespace = 'fanfanlo/javajs/v1/project/components/actions/script/'
